var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "file-type-doc",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.25,
    height: 30,
    viewBox: "0 0 23.25 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M16.483,0H.791C.354,0,0,.351,0,1.032V29.464c0,.185.354.536.791.536H22.459c.437,0,.791-.351.791-.536V6.952c0-.373-.05-.493-.139-.581L16.819.138A.48.48,0,0,0,16.483,0Z",
    transform: "translate(0 0)",
    fill: "#f2f2e8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M22.349.108V6.455h6.407Z",
    transform: "translate(-5.587 -0.027)",
    fill: "#d9d7ca"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M22.459,36.964H.791A.787.787,0,0,1,0,36.181V27.857H23.25v8.323A.787.787,0,0,1,22.459,36.964Z",
    transform: "translate(0 -6.965)",
    fill: "#0096e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M7.322,8.929H4.107a.536.536,0,1,1,0-1.071H7.322a.536.536,0,1,1,0,1.071Z",
    transform: "translate(-0.893 -1.965)",
    fill: "#8697cb"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M8.929,12.5H4.107a.536.536,0,0,1,0-1.071H8.929a.536.536,0,1,1,0,1.071Z",
    transform: "translate(-0.893 -2.857)",
    fill: "#8697cb"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M13.393,12.5a.53.53,0,1,1,.38-.155A.563.563,0,0,1,13.393,12.5Z",
    transform: "translate(-3.214 -2.859)",
    fill: "#8697cb"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M20.536,12.5H16.25a.536.536,0,0,1,0-1.071h4.286a.536.536,0,1,1,0,1.071Z",
    transform: "translate(-3.929 -2.857)",
    fill: "#8697cb"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M4.107,23.216a.537.537,0,1,1,.38-.916.553.553,0,0,1,.155.38.531.531,0,0,1-.536.536Z",
    transform: "translate(-0.893 -5.538)",
    fill: "#8697cb"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M11.25,23.214H6.964a.536.536,0,0,1,0-1.071H11.25a.536.536,0,0,1,0,1.071Z",
    transform: "translate(-1.607 -5.535)",
    fill: "#8697cb"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M25.893,12.5H24.821a.536.536,0,1,1,0-1.071h1.071a.536.536,0,1,1,0,1.071Z",
    transform: "translate(-6.071 -2.857)",
    fill: "#8697cb"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M15.893,16.071H4.107a.536.536,0,1,1,0-1.071H15.893a.536.536,0,1,1,0,1.071Z",
    transform: "translate(-0.893 -3.75)",
    fill: "#8697cb"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M25.178,16.071H21.964a.536.536,0,1,1,0-1.071h3.214a.536.536,0,1,1,0,1.071Z",
    transform: "translate(-5.357 -3.75)",
    fill: "#8697cb"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M6.25,19.643H4.107a.536.536,0,0,1,0-1.071H6.25a.536.536,0,0,1,0,1.071Z",
    transform: "translate(-0.893 -4.643)",
    fill: "#8697cb"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M15.179,19.643H9.821a.536.536,0,0,1,0-1.071h5.357a.536.536,0,1,1,0,1.071Z",
    transform: "translate(-2.321 -4.643)",
    fill: "#8697cb"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M24.643,19.643H19.821a.536.536,0,1,1,0-1.071h4.821a.536.536,0,1,1,0,1.071Z",
    transform: "translate(-4.821 -4.643)",
    fill: "#8697cb"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M10.69,33.21a3.964,3.964,0,0,1-.143,1.139,2.831,2.831,0,0,1-.363.791,1.864,1.864,0,0,1-.494.5,2.483,2.483,0,0,1-.531.275,2.191,2.191,0,0,1-.469.117,3.134,3.134,0,0,1-.314.025H6.333v-5.4H7.958a3.089,3.089,0,0,1,1.2.216,2.486,2.486,0,0,1,.857.575,2.361,2.361,0,0,1,.509.816A2.7,2.7,0,0,1,10.69,33.21Zm-2.607,2.2a1.455,1.455,0,0,0,1.289-.571,2.9,2.9,0,0,0,.4-1.655,2.805,2.805,0,0,0-.08-.666,1.426,1.426,0,0,0-.311-.6,1.643,1.643,0,0,0-.626-.432,2.7,2.7,0,0,0-1.025-.165H7.211v4.087Z",
    transform: "translate(-1.583 -7.665)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M17.769,33.3a3.823,3.823,0,0,1-.172,1.2,2.449,2.449,0,0,1-.476.864,1.992,1.992,0,0,1-.71.52,2.341,2.341,0,0,1-1.78,0,1.992,1.992,0,0,1-.71-.52,2.455,2.455,0,0,1-.476-.864,4.267,4.267,0,0,1,0-2.4,2.442,2.442,0,0,1,.476-.86,2.036,2.036,0,0,1,.71-.524,2.3,2.3,0,0,1,1.78,0,2.036,2.036,0,0,1,.71.524,2.468,2.468,0,0,1,.476.86A3.8,3.8,0,0,1,17.769,33.3ZM15.5,35.348a1.289,1.289,0,0,0,.516-.106,1.155,1.155,0,0,0,.439-.348,1.762,1.762,0,0,0,.3-.634,3.81,3.81,0,0,0,.117-.956,3.738,3.738,0,0,0-.114-.934,1.873,1.873,0,0,0-.293-.634,1.129,1.129,0,0,0-.425-.359,1.18,1.18,0,0,0-.5-.11,1.322,1.322,0,0,0-.516.1,1.106,1.106,0,0,0-.439.348,1.792,1.792,0,0,0-.3.634,3.738,3.738,0,0,0-.117.952,3.787,3.787,0,0,0,.114.938,1.836,1.836,0,0,0,.293.634,1.175,1.175,0,0,0,.425.359A1.156,1.156,0,0,0,15.5,35.348Z",
    transform: "translate(-3.318 -7.636)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M24.541,35.479a2,2,0,0,1-.681.439,2.257,2.257,0,0,1-.82.146,2.215,2.215,0,0,1-.89-.176,1.992,1.992,0,0,1-.71-.52,2.455,2.455,0,0,1-.476-.864,4.269,4.269,0,0,1,0-2.4,2.442,2.442,0,0,1,.476-.86,2.026,2.026,0,0,1,.714-.524,2.18,2.18,0,0,1,.886-.179,2.268,2.268,0,0,1,.82.146,2,2,0,0,1,.681.439l-.608.542a1.11,1.11,0,0,0-.407-.308,1.178,1.178,0,0,0-.465-.1,1.322,1.322,0,0,0-.516.1,1.106,1.106,0,0,0-.439.348,1.789,1.789,0,0,0-.3.634,3.738,3.738,0,0,0-.117.952,3.783,3.783,0,0,0,.114.938,1.836,1.836,0,0,0,.293.634,1.174,1.174,0,0,0,.425.359,1.146,1.146,0,0,0,.5.114,1.286,1.286,0,0,0,.494-.1,1.16,1.16,0,0,0,.421-.307Z",
    transform: "translate(-5.198 -7.636)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.165a37f163d86e4dc893fa55480acb60.svg";
export { ForwardRef as ReactComponent };